import { render, staticRenderFns } from "./SmallCampaignBlock.vue?vue&type=template&id=bda01d5c&scoped=true"
import script from "./SmallCampaignBlock.vue?vue&type=script&lang=js"
export * from "./SmallCampaignBlock.vue?vue&type=script&lang=js"
import style0 from "./SmallCampaignBlock.vue?vue&type=style&index=0&id=bda01d5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda01d5c",
  null
  
)

export default component.exports